import React from "react";
import { useLang } from "../lib/i18n";
import { Languages } from "lucide-react";

export const LangToggle = () => {
  const { lang, toggle } = useLang();
  return (
    <button data-testid="lang-toggle" onClick={toggle}
      className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-bold text-slate-700 shadow-sm transition hover:border-blue-300 hover:text-blue-700">
      <Languages className="h-3.5 w-3.5" />
      {lang === "it" ? "IT" : "EN"}
    </button>
  );
};
